import 'core-js/es6/map';
import 'core-js/es6/set';
import React from 'react';
import ReactDOM from 'react-dom';
import {createStore, applyMiddleware} from 'redux';
import {Provider} from 'react-redux';
import thunk from 'redux-thunk';
import reducer from './reducers/app.js';
import './reset.css';
import './index.css';
import App from './app.js';

const store = createStore(
  reducer,
  applyMiddleware(thunk),
);

ReactDOM.render(
  <Provider store={store}><App/></Provider>,
  document.getElementById('root')
);
// registerServiceWorker();

// renderApp(window.location.pathname, window.location.hash); // render the page the first time
// 
// window.addEventListener('popstate', function(e) {
//   renderApp(window.location.pathname, window.location.hash); // render page when path changes
// });
// 
// function renderApp(path, hash) {
//   const config = new Config();
//   const endpoints = new Endpoints(config);
//   ReactGA.initialize(
//     config.gaCode,
//     { 
//       debug: false,
//       gaOptions: {
//         cookieDomain: endpoints.masterDomain()
//       }
//     }
//   );
//   ReactGA.set({ dimension1: 'seller' });
//   ReactDOM.render(
//     <App path={path} hash={hash} config={config} endpoints={endpoints}/>,
//     document.getElementById('root')
//   );
// }



// WEBPACK FOOTER //
// ./src/index.js